<template>

  <div>

    <list-filters
      :trigger-filter.sync="triggerFilter"
      :data-filter.sync="dataFilter"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Tampilkan</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entri</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <h6 class="mr-1" v-if="attr != 'm4h5s5523' && attr != 'a4d5m5221'">Lihat Data Sebagai</h6>
              <v-select
                v-if="attr != 'm4h5s5523' && attr != 'a4d5m5221'"
                v-model="searchQuery"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="lihatSebagaiOptions.options"
                class="w-50"
                :reduce="val => val.value"
                :clearable="false"
                placeholder="Lihat Sebagai"
              />
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchDatas"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Tidak ada data yang ditemukan"
        :sort-desc.sync="isSortDirDesc"
        style="text-align:center;"
      >

        <!-- Column: User -->
        <template #cell(status_jadwal)="data">
          <b-media vertical-align="center">
              <b-badge pill :variant="'light-'+data.item.color" >{{ data.item.status_jadwal }}</b-badge>
          </b-media>
        </template>

        <template #cell(link_zoom)="data">
            <div class="d-flex justify-content-center">
               <b-button class="mr-1 btn-icon btn btn-relief-primary" variant="primary" target="_blank" :href="data.item.link_zoom"
            >
              <feather-icon icon="GlobeIcon" />
            </b-button>
            </div>
        </template>

        <template #cell(dosen_sidang)="data">
            <div class="d-flex justify-content-center">
               <b-button v-b-modal="'modal-center'+data.item.id" size="md" variant="success">Lihat</b-button>
                <b-modal :id="'modal-center'+data.item.id" centered title="">
                  <h5>Dosen Pembimbing</h5>
                  <div v-for="(item, index) in data.item.dosen_pembimbing" :key="'dpem'+index">
                    <label for="" v-if="item.pembimbing_utama !== 3">Dosen Pembimbing {{index += 1}}</label>
                    <label for="" v-if="item.pembimbing_utama === 3">Dosen Pembimbing Akademik</label>
                    <b-form-input :value="item.nama" readonly class="mb-2"/>
                  </div>
                  <h5 class="mt-3">Dosen Penguji</h5>
                  <div v-for="(item, index) in data.item.dosen_penguji" :key="'dpeng'+index">
                    <label for="">Dosen Penguji {{index += 1}}</label>
                    <b-form-input :value="item.nama" readonly class="mb-2"/>
                  </div>
                </b-modal>
            </div>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="d-flex justify-content-center">
            <!-- <b-button class="mr-1 btn-icon btn btn-relief-primary" variant="info" :to="{ name: 'pengajuan-sidang-readonly', params: { uuid: data.item.pengajuan_sidang } }" title="Lihat Data"
            >
              <feather-icon icon="SearchIcon" />
            </b-button> -->
            <b-button v-if="$can('manage','all-content') || $can('change','dosen-jadwal-sidang')" class="mr-1 btn-icon btn btn-relief-primary" variant="primary" :to="{ name: 'jadwal-sidang-edit', params: { uuid: data.item.uuid } }" title="Edit Data"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button class="mr-1 btn-icon btn btn-relief-primary" v-b-modal="'modal-center-mulai-sidang'+data.item.uuid" variant="success" title="Mulai Sidang" v-if=" data.item.status_jadwal == 'Belum Mulai' && data.item.status_sidang == 'Terjadwal' && data.item.pembimbing_utama == 'ya'"
            >
              <feather-icon icon="PlayIcon" />
            </b-button>
                <b-modal :id="'modal-center-mulai-sidang'+data.item.uuid" centered title="Konfirmasi" :hide-footer="true">
                    <center><p>Apakah anda yakin ingin memulai sidang {{data.item.judul}}?</p></center>
                    <center class="mt-3">
                      <b-button class="mr-1" variant="primary" @click="mulaiSidang(data.item.role, data.item.uuid)" :disabled="btn_disabled == 1">Ya</b-button>
                      <b-button variant="danger" @click="this.$root.$emit('bv::show::modal', 'modal-center-mulai-sidang')">Tidak</b-button>
                    </center>
                </b-modal>
          </div>           
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Tampilkan {{ dataMeta.from }} hingga {{ dataMeta.to }} dari {{ dataMeta.of }} entri</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  postMulaiSidang
} from '@/connection-api/master'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/connection-api/jadwal-sidang/storeModule'
import useList from '@/connection-api/jadwal-sidang/list'
import listFilters from './ListFilters.vue'

export default {
  components: {
    listFilters,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    // BLink,
    BDropdown,
    BDropdownItem,
    BPagination,
    BBadge,

    vSelect,
  },
  data() {
    return {
      btn_disabled: 0,
      attr: null,
      jenisUptOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis UPT --' },
        ],
      },
      kanwilOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Kanwil --' },
        ],
      },
      uptOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih UPT --' },
        ],
      },
      jenisAssetOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Asset --' },
        ],
      },
      statusAssetOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Status Asset --' },
        ],
      },
      lihatSebagaiOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Lihat Sebagai --' },
          { value: 'pembimbing', label: 'Pembimbing' },
          { value: 'penguji', label: 'Penguji' },
        ],
      },
    }
  },
  async mounted() {
    this.searchQuery = 'pembimbing';
    const userDataString = localStorage.getItem('userData')
    const userDataArray = JSON.parse(userDataString)
    this.attr = userDataArray.attr
  },
  methods: {
    async mulaiSidang(role, uuid){
      this.btn_disabled = 1
      var data = {
        uuid: uuid,
        role: role,
      }
      const response = await postMulaiSidang(data)
      if(response.data.success === true){
        this.btn_disabled = 0
        this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Jadwal Sidang',
              icon: 'CoffeeIcon',
              variant: 'success',
              text: 'Data berhasil di simpan',
            },
          })
          this.refetchData()
          this.$root.$emit('bv::hide::modal', 'modal-center-mulai-sidang'+uuid)
      }else{
        this.btn_disabled = 0
        this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Jadwal Sidang',
              icon: 'CoffeeIcon',
              variant: 'danger',
              text: response.data.message,
            },
          })
      }
      this.$root.$emit('bv::hide::modal', 'modal-center-mulai-sidang'+uuid)
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'jadwal-sidang'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)

    const {
      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      triggerFilter,
      dataFilter,
    } = useList()

    return {

      // Sidebar
      isAddNewUserSidebarActive,

      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      triggerFilter,
      dataFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
